var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "link",
    transform: "translate(-1522 -12353)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6847",
    "data-name": "Rectangle 6847",
    width: 32,
    height: 32,
    rx: 5,
    transform: "translate(1522 12353)",
    fill: "#02a2ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-linkedin-in",
    "data-name": "Icon awesome-linkedin-in",
    d: "M4.1,18.325H.3V6.091H4.1ZM2.2,4.422A2.211,2.211,0,1,1,4.4,2.2,2.219,2.219,0,0,1,2.2,4.422Zm16.121,13.9H14.53V12.37c0-1.419-.029-3.24-1.975-3.24-1.975,0-2.278,1.542-2.278,3.137v6.058h-3.8V6.091h3.644V7.76h.053a3.992,3.992,0,0,1,3.595-1.976c3.845,0,4.552,2.532,4.552,5.821v6.721Z",
    transform: "translate(1529 12359.836)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.4d7613a13a5a317c2469d3864367a1cd.svg";
export { ForwardRef as ReactComponent };